import React from 'react'
import SelectionContext from '../contexts/SelectionContext'

export default function useSelection () {
  return React.useContext(SelectionContext)
}
